import React from 'react';
import { Button, Upload } from 'antd';
import { ReactComponent as AddIcon } from '@/assets/icons/add.svg';
import { useTranslation } from 'react-i18next';
import '@/assets/convert.less';

const ConvertWorkHeaderRender = ({
  files,
  uploadProps,
  handleAddFileMoreThanLimit,
}) => {
  const { t } = useTranslation(['convert']);
  return (
    <div className='header'>
      {files.length >= 1 &&
      !files.some(
        (item) => item.status === 'converting' || item.status === 'uploading'
      ) ? (
        <Button
          className='addFileBtn'
          type='primary'
          ghost
          // icon={<AddIcon />}
          onClick={handleAddFileMoreThanLimit}
        >
          {t('Batch Processing')}
        </Button>
      ) : (
        <Upload {...uploadProps}>
          <Button
            type='primary'
            disabled={files.some(
              (item) =>
                item.status === 'converting' || item.status === 'uploading'
            )}
            ghost
            // icon={<AddIcon />}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            {t('Batch Processing')}
          </Button>
        </Upload>
      )}
    </div>
  );
};

export default ConvertWorkHeaderRender;
